import React from "react"

export default function PartneringGetform() {
  return (
    <div className="space-y-4">
      <h4 className="text-2xl font-heavy">Contact us:</h4>
      <form
        className="form"
        action="https://getform.io/f/e4db2cd2-eb3c-4695-9006-cd6ff91dbae9"
        method="POST"
      >
        {/* Honeypot field for spam prevention */}
        <input type="hidden" name="_gotcha" style={{ display: 'none' }} />

        <div className="md:grid md:grid-cols-2 md:gap-4">
          <div>
            <label htmlFor="yourName">
              Name:<span className="text-brandorange"></span>
              <input
                type="text"
                name="yourName"
                required
              />
            </label>
          </div>
          <div>
            <label htmlFor="yourEmail">
              Email:<span className="text-brandorange"></span>
              <input
                type="email"
                id="yourEmail"
                name="yourEmail"
                required
              />
            </label>
          </div>

          <div>
            <label htmlFor="company">
              Company
              <input
                type="text"
                name="company"
              />
            </label>
          </div>
        </div>

        <div>
          <label htmlFor="description" className="flex flex-col">
            General description and inquire
            <textarea
              rows="8"
              name="description"
              required
            />
          </label>
        </div>

        <button type="submit">
          Send
        </button>
      </form>
    </div>
  )
}
